import { render, staticRenderFns } from "./agendamento_especialidade_recepcionista.vue?vue&type=template&id=ac27251a&scoped=true"
import script from "./agendamento_especialidade_recepcionista.vue?vue&type=script&lang=js"
export * from "./agendamento_especialidade_recepcionista.vue?vue&type=script&lang=js"
import style0 from "./agendamento_especialidade_recepcionista.vue?vue&type=style&index=0&id=ac27251a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac27251a",
  null
  
)

export default component.exports